module.exports = __webpack_public_path__ + "static/media/pin-warning.c368626e.png";